// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "" + {"218":"component---src-pages-404-tsx","691":"component---src-pages-index-tsx"}[chunkId] + "-" + {"218":"8a1b77ae260b92fef3d8","691":"a9e4f7ec8174cb56fecd"}[chunkId] + ".js";
};